import React from 'react';
import './sub1.css';
import { Helmet } from 'react-helmet';
import contactConfig from '../../confi';
export default function Cook() {
  // Cook services data
  const cookServices = [
    {
      id: 1,
      title: "Daily Meal Preparation",
      description: "Fresh, healthy meals prepared daily according to your dietary preferences and family needs.",
      features: [
        "Breakfast, lunch, and dinner preparation",
        "Traditional Gujarati, Punjabi, South Indian dishes",
        "Customized meal plans",
        "Fresh ingredient usage",
        "Kitchen cleanup included"
      ],
      image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "🍽️",
      price: "₹4,999/month"
    },
    {
      id: 2,
      title: "Special Diet Cooking",
      description: "Expert cooking for specific dietary needs including diabetic, keto, vegan, Jain, and gluten-free diets.",
      features: [
        "Continental, Jain, and diet-based meals",
        "Health-focused cooking",
        "Senior-friendly diets",
        "Kids' special meals",
        "Customized nutrition plans"
      ],
      image: "https://images.unsplash.com/photo-1490818387583-1baba5e638af?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "🥗",
      price: "₹6,999/month"
    },
    {
      id: 3,
      title: "Party & Event Cooking",
      description: "Professional cooking services for parties, events, and special occasions at your home.",
      features: [
        "Event-based and party cooking",
        "Multiple cuisine options",
        "Bulk cooking expertise",
        "Serving assistance",
        "Complete cleanup"
      ],
      image: "https://images.unsplash.com/photo-1547592180-85f173990554?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "🎉",
      price: "₹8,999/event"
    },
    {
      id: 4,
      title: "Traditional Cuisine Experts",
      description: "Authentic traditional cooking from various regions including Gujarati, Punjabi, South Indian, and Rajasthani.",
      features: [
        "Traditional Gujarati specialties",
        "Punjabi and North Indian dishes",
        "South Indian authentic flavors",
        "Rajasthani cuisine",
        "Family recipe cooking"
      ],
      image: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "👨‍🍳",
      price: "₹5,999/month"
    },
    {
      id: 5,
      title: "Weekly Meal Prep & Tiffin",
      description: "Home-style tiffin and bulk meal preparation for the entire week, perfect for busy families.",
      features: [
        "Home-style tiffin service",
        "Weekly meal planning",
        "Bulk cooking sessions",
        "Proper food storage",
        "Grocery shopping included"
      ],
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "📦",
      price: "₹7,499/month"
    },
    {
      id: 6,
      title: "Veg & Non-Veg Cooking",
      description: "Complete cooking services for both vegetarian and non-vegetarian preferences with hygiene focus.",
      features: [
        "Veg and non-veg options",
        "Separate cooking utensils",
        "Hygiene-focused preparation",
        "Quality meat handling",
        "Customized preferences"
      ],
      image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&h=400&q=80",
      icon: "🍖",
      price: "₹6,499/month"
    }
  ];

  const cuisineTypes = [
    {
      name: "Gujarati",
      description: "Traditional Gujarati thali with dal, roti, shaak, and sweets",
      image: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80"
    },
    {
      name: "Punjabi",
      description: "Rich, creamy curries and tandoori specialties",
      image: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80"
    },
    {
      name: "South Indian",
      description: "Healthy, flavorful dishes with rice, lentils, and spices",
      image: "https://images.unsplash.com/photo-1546833999-b9f581a1996d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80"
    },
    {
      name: "Continental & Jain",
      description: "European-style cooking and Jain dietary compliant meals",
      image: "https://images.unsplash.com/photo-1563245372-f21724e3856d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=200&q=80"
    }
  ];

  const whyChooseOurCooks = [
    {
      title: "Verified & Experienced Cooks",
      description: "Every cook is identity and background verified for your safety with years of experience.",
      icon: "✅"
    },
    {
      title: "Multi-Cuisine Expertise",
      description: "From local favorites to international dishes — trained in diverse cuisines.",
      icon: "🍛"
    },
    {
      title: "Hygiene & Cleanliness",
      description: "Strict hygiene standards and clean kitchen practices maintained.",
      icon: "✨"
    },
    {
      title: "Customized Meal Plans",
      description: "Meals prepared according to your dietary needs and preferences.",
      icon: "📋"
    }
  ];

  const serviceFeatures = [
    {
      icon: "🍽️",
      text: "Breakfast, lunch, and dinner preparation"
    },
    {
      icon: "🏺",
      text: "Traditional Gujarati, Punjabi, South Indian, and Rajasthani dishes"
    },
    {
      icon: "🥗",
      text: "Continental, Jain, and diet-based meals"
    },
    {
      icon: "🍖",
      text: "Veg and non-veg cooking options"
    },
    {
      icon: "🎉",
      text: "Event-based and party cooking"
    },
    {
      icon: "📦",
      text: "Home-style tiffin and meal prep assistance"
    }
  ];

  const processSteps = [
    {
      step: "1",
      title: "Share Your Requirement",
      description: "Tell us your cuisine preferences, timing, and number of family members"
    },
    {
      step: "2",
      title: "Receive Cook Profiles",
      description: "We'll send you verified profiles of available cooks in your area"
    },
    {
      step: "3",
      title: "Interview & Finalize",
      description: "Meet and select the cook who best fits your family's style and taste"
    },
    {
      step: "4",
      title: "Service Begins",
      description: "Once confirmed, the cook starts as per your chosen schedule"
    },
    {
      step: "5",
      title: "After-Support & Replacements",
      description: "Our support team ensures smooth service and satisfaction"
    }
  ];

  const testimonials = [
    {
      name: "Mr. & Mrs. Shah",
      location: "Vastrapur, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "We hired a cook through JP Home Services, and it's been a wonderful experience. The meals are tasty, hygienic, and perfectly timed for our busy routine."
    },
    {
      name: "Mrs. Hetal Mehta",
      location: "Surat",
      rating: "⭐⭐⭐⭐⭐",
      text: "Their cook service in Surat is amazing. Our cook prepares both Gujarati and North Indian dishes with consistency and cleanliness."
    },
    {
      name: "Mr. Rahul Desai",
      location: "Vadodara",
      rating: "⭐⭐⭐⭐⭐",
      text: "I travel often for work, and the cook from JP Home Services ensures my parents always get fresh, healthy meals. Highly professional team!"
    }
  ];

  const benefits = [
    "Verified, skilled, and reliable cooks",
    "Clean, hygienic, and timely meal preparation",
    "Transparent pricing and flexible plans",
    "Multiple cuisine options — Indian & international",
    "Replacement guarantee for peace of mind",
    "Services across Ahmedabad, Surat, Vadodara, Rajkot, and Gandhinagar",
    "Dedicated support and feedback monitoring"
  ];

  const cities = [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar", "Anand", "Bhavnagar", "Jamnagar"
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Hire Verified Personal Cook Services in Ahmedabad - JP Home</title>
        <meta
          name="description"
          content="Book trusted hygienic cook services in Ahmedabad for part-time and full-time. JP Home Services offers verified & expert cooks. Call +91 9328843812 now!"
        />
        <meta
          name="keywords"
          content=" Cook Services Ahmedabad, Personal Cook Ahmedabad, Home Chef Services Gujarat, Full-time Cook Ahmedabad, Part-time Cook Gujarat, Home Cooking Services Ahmedabad, Trained Cooks Gujarat"
        />
        <meta property="og:title" content="Hire Verified Personal Cook Services in Ahmedabad - JP Home" />
        <meta
          property="og:description"
          content="Book trusted hygienic cook services in Ahmedabad for part-time and full-time. JP Home Services offers verified & expert cooks. Call +91 9328843812 now!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://jphomeservice.in/static/media/maid%20indian.d4e03a469f507759a2ab.jpg" />
        <meta property="og:url" content="https://jphomeservice.in/cook-services-in-ahmedabad" />
        <meta property="og:site_name" content="JP Home Services" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta name="twitter:image" content="https://jphomeservice.in/static/media/maid%20indian.d4e03a469f507759a2ab.jpg" />
        <meta name="twitter:title" content="Hire Verified Personal Cook Services in Ahmedabad - JP Home" />
        <meta
          name="twitter:description"
          content="Book trusted hygienic cook services in Ahmedabad for part-time and full-time. JP Home Services offers verified & expert cooks. Call +91 9328843812 now!"
        />
        <link rel="canonical" href="https://jphomeservice.in/cook-services-in-ahmedabad" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        {/* JSON-LD */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": "https://jphomeservice.in/cook-services-in-ahmedabad#webpage",
              "url": "https://jphomeservice.in/cook-services-in-ahmedabad",
              "name": "Hire Personal Cook Services in Ahmedabad - JP Home Services",
              "description": "JP Home Services offers reliable cook services in Ahmedabad with experienced house cooks for daily meals. Enjoy healthy, hygienic & tasty food at home.",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "@id": "https://jphomeservice.in/#website",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://jphomeservice.in/#organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              }
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Cook Service in Ahmedabad",
              "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "@id": "",
              "url": "https://jphomeservice.in/cook-services-in-ahmedabad",
              "telephone": "+919327365056",
              "priceRange": "₹₹",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
                "addressLocality": "Ahmedabad, Gujarat",
                "postalCode": "380013",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 23.0542109,
                "longitude": 72.5482134
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ] 
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Cook Services in Ahmedabad",
            "serviceType": "Cook Services",
            "description": "JP Home Service provides reliable cook services in Ahmedabad for daily cooking, meal preparation, and household food requirements.",
            "url": "https://jphomeservice.in/cook-services-in-ahmedabad",
            "areaServed": {
              "@type": "City",
              "name": "Ahmedabad"
            },
            "provider": {
              "@type": "Organization",
              "name": "JP Home Service",
              "url": "https://jphomeservice.in/"
            }
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org/", 
            "@type": "BreadcrumbList", 
            "itemListElement": [{
              "@type": "ListItem", 
              "position": 1, 
              "name": "Home",
              "item": "https://jphomeservice.in"  
            },{
              "@type": "ListItem", 
              "position": 2, 
              "name": "Cook Services in Ahmedabad",
              "item": "https://jphomeservice.in/cook-services-in-ahmedabad"  
            }]
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/cook-services-in-ahmedabad#review-shah",
                "url": "https://jphomeservice.in/cook-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mr. & Mrs. Shah"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "We hired a cook through JP Home Services, and it's been a wonderful experience. The meals are tasty, hygienic, and perfectly timed for our busy routine."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/cook-services-in-ahmedabad#review-hetal-mehta",
                "url": "https://jphomeservice.in/cook-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Hetal Mehta"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "Their cook service in Surat is amazing. Our cook prepares both Gujarati and North Indian dishes with consistency and cleanliness."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/cook-services-in-ahmedabad#review-rahul-desai",
                "url": "https://jphomeservice.in/cook-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mr. Rahul Desai"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "I travel often for work, and the cook from JP Home Services ensures my parents always get fresh, healthy meals. Highly professional team!"
              },
              {
                "@type": "AggregateRating",
                "@id": "https://jphomeservice.in/cook-services-in-ahmedabad#aggregate-rating",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "ratingValue": 5,
                "bestRating": 5,
                "worstRating": 1,
                "reviewCount": 3
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <div className="main-content-wrapper">
        {/* Hero Section */}
        <section className="cook-hero-section">
          <div className="container">
            <div className="cook-hero-content">
              <h1>Cook Services in Ahmedabad, Surat & Major Cities of Gujarat</h1>
              <p><strong>Delicious Meals, Expert Hands – Your Trusted Home Cook Service Partner</strong></p>
              <p>Good food brings families together — and at JP Home Services, we make sure every meal feels like home. We offer professional cook services in Ahmedabad, Surat, Vadodara, Rajkot, and across Gujarat, connecting you with skilled, hygienic, and verified cooks who prepare meals tailored to your taste, lifestyle, and dietary preferences.</p>
              <p>Whether you're a busy professional, a family that loves traditional food, or someone seeking a personal chef experience at home — we provide reliable cooking staff who understand your kitchen like their own.</p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span>100+</span>
                  <p>Expert Cooks</p>
                </div>
                <div className="stat-item">
                  <span>50+</span>
                  <p>Cuisine Types</p>
                </div>
                <div className="stat-item">
                  <span>1000+</span>
                  <p>Happy Families</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Features Section */}
        <section className="service-features-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Cook Service Features</h2>
              <p>At JP Home Services, we believe cooking is more than a chore — it's an art that requires care, hygiene, and heart. Our trained cooks specialize in a wide variety of cuisines and daily meal preparations to suit your family's preferences.</p>
            </div>

            <div className="features-grid">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon1">{feature.icon}</div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="flexibility-note">
              <p><strong>Choose full-time, part-time, or live-in cooks</strong> — we have options for every home and schedule.</p>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="cook-services-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Professional Cook Services</h2>
              <p>Comprehensive cooking solutions for every need and occasion</p>
            </div>

            <div className="services-grid">
              {cookServices.map(service => (
                <div key={service.id} className="service-card">
                  <div className="service-image">
                    <img src={service.image} alt={service.title} />
                    <div className="service-icon">{service.icon}</div>
                    {/* <div className="service-price">{service.price}</div> */}
                  </div>
                  <div className="service-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <ul className="service-features">
                      {service.features.map((feature, index) => (
                        <li key={index}> {feature}</li>
                      ))}
                    </ul>
                    <button className="service-enquiry-btn">Book Service</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div
            className="contact-icon call-icon"
            onClick={handleCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>


        {/* Why Choose Us Section */}
        <section className="why-choose-cook-section">
          <div className="container">
            <div className="section-header1">
              <h2>Why Choose Cooks from JP Home Services</h2>
              <p>Our goal is to bring taste, hygiene, and trust to your dining table every day. Here's why hundreds of families in Gujarat choose JP Home Services for their cook requirements:</p>
            </div>

            <div className="features-grid">
              {whyChooseOurCooks.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>Flexible Timings - Choose your preferred slot — morning, evening, or full-day service</span>
              </div>
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>Replacement Guarantee - Immediate replacement if unsatisfied — ensuring zero disruption</span>
              </div>
            </div>

            <div className="trust-note">
              <p><strong>Because we understand — good food starts with good hands.</strong></p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header1">
              <h2>How Our Cook Service Works</h2>
              <p>Hiring a professional cook through JP Home Services is simple and transparent:</p>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="process-conclusion">
              <p><strong>From selection to satisfaction — your comfort is our priority.</strong></p>
            </div>
          </div>
        </section>

        {/* Cuisine Types Section */}
        <section className="cuisine-section">
          <div className="container">
            <div className="section-header1">
              <h2>Explore Cuisine Types</h2>
              <p>Diverse culinary expertise from traditional to international cuisines</p>
            </div>

            <div className="cuisine-grid">
              {cuisineTypes.map((cuisine, index) => (
                <div key={index} className="cuisine-card">
                  <img src={cuisine.image} alt={cuisine.name} />
                  <div className="cuisine-content">
                    <h3>{cuisine.name}</h3>
                    <p>{cuisine.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container">
            <div className="section-header">
              <h2>What Our Clients Say</h2>
            </div>

            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="container">
            <div className="section-header1">
              <h2>Benefits of Choosing JP Home Services for Cook Services</h2>
              <p>When you choose JP Home Services, you enjoy more than convenience — you experience trust, taste, and professionalism.</p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item-large">
                  <span className="check-icon">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <div className="brand-tagline">
              <p><strong>From homely meals to festive feasts — JP Home Services makes every meal special.</strong></p>
            </div>
          </div>
        </section>
        {/* <section className="cook-pricing-section">
        <div className="container">
          <div className="section-header1">
            <h2>Flexible Pricing Plans</h2>
            <p>Choose the perfect plan that suits your family's needs</p>
          </div>

          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>Basic Plan</h3>
              <div className="price">₹3,999<span>/month</span></div>
              <ul className="pricing-features">
                <li>✓ 2 meals per day</li>
                <li>✓ 5 days a week</li>
                <li>✓ Basic Indian cuisine</li>
                <li>✓ Vegetarian options</li>
                <li>✗ Special diets</li>
                <li>✗ Weekend service</li>
              </ul>
              <button className="pricing-btn">Choose Plan</button>
            </div>

            <div className="pricing-card popular">
              <div className="popular-badge">Most Popular</div>
              <h3>Standard Plan</h3>
              <div className="price">₹6,999<span>/month</span></div>
              <ul className="pricing-features">
                <li>✓ 3 meals per day</li>
                <li>✓ 6 days a week</li>
                <li>✓ Multiple cuisines</li>
                <li>✓ Veg & Non-veg</li>
                <li>✓ Basic special diets</li>
                <li>✗ Party cooking</li>
              </ul>
              <button className="pricing-btn primary">Choose Plan</button>
            </div>

            <div className="pricing-card">
              <h3>Premium Plan</h3>
              <div className="price">₹11,999<span>/month</span></div>
              <ul className="pricing-features">
                <li>✓ 3 meals per day</li>
                <li>✓ 7 days a week</li>
                <li>✓ All cuisines</li>
                <li>✓ All diet types</li>
                <li>✓ Weekend service</li>
                <li>✓ 2 party events/month</li>
              </ul>
              <button className="pricing-btn">Choose Plan</button>
            </div>
          </div>
        </div>
      </section> */}

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header1">
              <h2>Service Coverage</h2>
              <p>Our professional cook services are available across Gujarat:</p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>

            <div className="coverage-note">
              <p><strong>Whether you need a part-time cook for your daily meals or a full-time chef for your household, JP Home Services has the perfect solution for you.</strong></p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cook-cta-section">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Transform Your Dining Experience?</h2>
              <p>Book a free tasting session and experience the JP Home Services difference</p>
              <div className="cta-buttons1">
                <button
                  className="cta-btn1 secondary23 assistant-btn"
                  onClick={() => {
                    const number = `${contactConfig.phone}`;
                    window.history.pushState({}, "", `/call/${number}`);
                    if (window.gtag) {
                      window.gtag("event", "conversion", {
                        send_to: "AW-16629382441/EFuzCL_s9cIbEKn6wPk9",
                      });
                    }
                    setTimeout(() => {
                      window.location.href = `tel:${number}`;
                    }, 600);
                  }}
                >
                  Call Now: {contactConfig.phone}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}